import React from 'react';
import theme from './ProductMoreInfoModal.module.scss';
import { ButtonBar, Modal, ModalBody, ModalFooter, ModalHeader } from '@ygtechnologies/bygr-frontend-component-library';
import { Button } from '@ygtechnologies/rubus-ui';
import { Trans } from '@lingui/react/macro';
import { BaseProduct } from '@/types';
import { ProductMoreInfoModalContent } from './ProductMoreInfoModalContent';

export interface ProductMoreInfoModalProps {
    product: BaseProduct;
    isOpen: boolean;
    toggleModal: () => void;
}

export const ProductMoreInfoModal: React.FC<ProductMoreInfoModalProps> = ({ isOpen, toggleModal, product }) => {
    return (
        <Modal size="lg" isOpen={isOpen} toggle={toggleModal}>
            <ModalHeader />
            <ModalBody>
                <ProductMoreInfoModalContent product={product} showCategory />
            </ModalBody>

            <ModalFooter>
                <ButtonBar className={theme.buttonBar}>
                    <ButtonBar.Left />
                    <ButtonBar.Right>
                        <Button variant="tertiary" onClick={toggleModal}>
                            <Trans>Close</Trans>
                        </Button>
                    </ButtonBar.Right>
                </ButtonBar>
            </ModalFooter>
        </Modal>
    );
};
